import orderBy from 'lodash/orderBy'
import sum from 'lodash/sum'

export function clips(state) {
    return state.project.clips
}

export function clipsInPlayOrder(state) {
    return orderBy(state.project.clips, 'order', 'asc')
}

export function isLoaded(state) {
    return !!state.project
}

export function getClipById(state) {
    return id => state.project.clips.find(c => c.id == id)
}

export function totalOverallTime(state) {
    const durations = state.project.clips.map(getClipDuration)
    return sum(durations)
}

export function absoluteTime(state) {
    return state.currentVideoAbsoluteTime;
}

function getClipDuration(clip) {
    const startTime = clip.start_time || 0
    const endTime = clip.end_time || clip.video.duration
    return endTime - startTime
}

export function currentlyActiveClip(state, getters) {
    let activeClip = {};
    let time = state.currentVideoAbsoluteTime;

    getters.clipsInPlayOrder.forEach(clip => {
        let start = state.clipRanges[clip.id].start;
        let end = state.clipRanges[clip.id].end;
        
        if (time >= start && time <= end) {
            activeClip = clip;
        }
    });
    
    return activeClip;
}

export const getClipByTime = (state) => (absoluteTime) => {
    let total = 0

    const orderedClips = orderBy(state.project.clips, 'order', 'asc')

    for (const clip of orderedClips) {
        const startTime = clip.start_time || 0;
        const endTime = clip.end_time || clip.video.duration;
        const duration = endTime - startTime;

        if (total + duration >= absoluteTime) {
            return { clip, relativeTime: absoluteTime - total, clipAbsoluteTime: absoluteTime };
        }

        total += duration;
    }

    return null;
}